import styled from "styled-components";
import { motion } from "framer-motion";

// Custom CSS for drag and drop container
export const dragDropStyles = `
  .drag-drop-container::-webkit-scrollbar {
    width: 6px;
  }
  
  .drag-drop-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }
  
  .drag-drop-container::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }
  
  .drag-drop-container::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

// Main Layout Components
export const DashboardContainer = styled.section`
  background: #ededed;
  border-radius: 0;
  border: none;
  border-top: 0;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 2rem;
  box-shadow: none;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: 100%;
`;

export const DashboardTitle = styled.h2`
  font-size: 35px;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: #111827;
`;

export const DashboardTitleText = styled.span`
  display: inline-block;

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const DashboardCount = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.5rem;
  font-weight: 500;
  color: #6b7280;
  font-size: 1rem;
`;

export const DashboardControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border-radius: 12px;
  border: 1px solid rgba(17, 24, 39, 0.08);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 6px 16px rgba(0, 0, 0, 0.07),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    padding: 0.75rem;
  }

  @media (max-width: 480px) {
    gap: 0.5rem;
    padding: 0.5rem;
  }
`;

export const ControlLabel = styled.label`
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
`;

export const ControlSelect = styled.select`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${(props) => (props.$active ? "#3b82f6" : "#d1d5db")};
  border-radius: 6px;
  background: ${(props) => (props.$active ? "#eff6ff" : "transparent")};
  font-size: 0.8125rem;
  color: #1f2937;
  cursor: pointer;
  outline: none;
  min-width: 110px;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:focus {
    background-color: #ffffff;
    border-color: #3b82f6;
    outline: none;
  }

  &:hover {
    background-color: #ffffff;
    border-color: #9ca3af;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`;

export const ControlInput = styled.input`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${(props) => (props.$active ? "#3b82f6" : "#d1d5db")};
  border-radius: 6px;
  background: ${(props) => (props.$active ? "#eff6ff" : "transparent")};
  font-size: 0.8125rem;
  color: #1f2937;
  outline: none;
  min-width: 180px;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:focus {
    background-color: #ffffff;
    border-color: #3b82f6;
    outline: none;
  }

  &:hover {
    background-color: #ffffff;
    border-color: #9ca3af;
  }

  &::placeholder {
    color: #9ca3af;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`;

export const RefreshButton = styled.button`
  padding: 0.5rem 1rem;
  background: ${(props) => (props.$primary ? "#3b82f6" : "white")};
  color: ${(props) => (props.$primary ? "#ffffff" : "#374151")};
  border: 1px solid ${(props) => (props.$primary ? "#3b82f6" : "#e5e7eb")};
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: auto;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  white-space: nowrap;
  outline: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover:not(.disabled) {
    background: ${(props) => (props.$primary ? "#2563eb" : "#f3f4f6")};
    border-color: ${(props) => (props.$primary ? "#3b82f6" : "#9ca3af")};
  }

  &:active:not(.disabled) {
    background: ${(props) => (props.$primary ? "#1d4ed8" : "#e5e7eb")};
  }

  &:focus {
    outline: none;
  }

  &.disabled,
  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
    background: #f9fafb;
    color: #9ca3af;
    border-color: #e5e7eb;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  background: white;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 500;
  min-width: auto;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  outline: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  &:active {
    background: #f3f4f6;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const BatchName = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SegmentedToggle = styled.div`
  display: inline-flex;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e5e7eb;
`;

export const ToggleButton = styled.button`
  border: none;
  background: transparent;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  color: ${(props) => (props.active ? "#111827" : "#6b7280")};
  background: ${(props) => (props.active ? "white" : "transparent")};
  box-shadow: ${(props) =>
    props.active ? "0 1px 3px rgba(0,0,0,0.06)" : "none"};
  transition: all 0.15s ease;
`;

export const BatchCount = styled.span`
  font-weight: 500;
  color: #6b7280;
  font-size: 1rem;
`;

// Status Components
export const DashboardStatus = styled.p`
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 1.1rem;
`;

export const DashboardError = styled.p`
  text-align: center;
  padding: 2rem;
  color: #ef4444;
  font-size: 1.1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  margin: 1rem 0;
`;

// Table Components
export const TableContainer = styled.div`
  margin-bottom: 2rem;
  max-height: 70vh;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  background: transparent;
  border: 1px solid rgba(17, 24, 39, 0.08);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 6px 16px rgba(0, 0, 0, 0.07),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);

  /* Scrollable, scrollbar never shown */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  font-size: 0.875rem;
  min-width: 2600px;
  background: transparent;
  margin: 0;
`;

export const TableHead = styled.thead`
  background: #ededed;
  position: sticky;
  top: 0;
  z-index: 25;
  display: table-header-group;
  width: 100%;
`;

export const TableHeader = styled.th`
  padding: 0.75rem 1.25rem;
  text-align: left;
  font-weight: 600;
  color: #4b5563;
  border-bottom: 1px solid rgba(17, 24, 39, 0.16);
  white-space: nowrap;
  font-size: 14px;
  letter-spacing: 0.01em;
  background: #ededed;
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  position: sticky;
  top: 0;
  z-index: 25;
  vertical-align: middle;
  cursor: pointer;
`;

export const EditableHeader = styled(TableHeader)`
  padding-left: 1.75rem;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M12 20h9'/><path d='M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z'/></svg>");
  background-repeat: no-repeat;
  background-position: 10px center;
`;

export const CheckboxHeader = styled.th`
  padding: 0.75rem 0.5rem;
  text-align: center;
  border-bottom: 1px solid rgba(17, 24, 39, 0.16);
  background: #ededed;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 30;
  width: 40px;
  min-width: 40px;
  vertical-align: middle;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
`;

export const TableBody = styled.tbody``;

export const TableRow = styled(motion.tr)`
  &:last-child td {
    border-bottom: none;
  }

  ${(props) =>
    props.$highlighted &&
    `
    animation: rowPulseHighlight 0.7s ease-in-out 5;
  `}

  @keyframes rowPulseHighlight {
    0%,
    100% {
      background-color: transparent;
    }
    50% {
      background-color: #fca5a5;
    }
  }
`;

export const NoDataCell = styled.td`
  text-align: center;
  padding: 3rem 1rem;
  color: #6b7280;
  font-size: 1rem;
  font-weight: 500;
  background-color: #f3f3f3;
  border: none;
`;

export const TableCell = styled.td`
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid rgba(17, 24, 39, 0.08);
  vertical-align: middle;
  white-space: nowrap;
  background: #f3f3f3;
  font-size: 0.875rem;
  font-weight: 500;
  color: black;
  cursor: pointer;
  transition: background-color 0.15s ease;
`;

export const CheckboxColumn = styled(TableCell)`
  width: 40px;
  min-width: 40px;
  text-align: center;
  position: sticky;
  left: 0;
  background: #f3f3f3;
  z-index: 20;
  padding: 0.75rem 0.5rem;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.15s ease;

  ${(props) =>
    props.$highlighted &&
    `
    animation: rowPulseHighlight 0.7s ease-in-out 5;
  `}
`;

export const ActionButtonColumn = styled(TableCell)`
  width: 56px;
  min-width: 56px;
  text-align: center;
  position: sticky;
  left: 40px;
  background: #f3f3f3;
  z-index: 19;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
`;

export const ActionButtonHeader = styled(TableHeader)`
  width: 56px;
  min-width: 56px;
  text-align: center;
  position: sticky;
  top: 0;
  left: 40px;
  z-index: 29;
  background: #ededed;
  cursor: default;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
`;

export const RowActionButton = styled.button`
  width: 28px;
  height: 28px;
  min-width: 28px;
  max-width: 28px;
  min-height: 28px;
  max-height: 28px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  background: #ffffff;
  color: #374151;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  appearance: none;
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.15s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  outline: none;

  &:hover {
    background: #f9fafb;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.08);
  }

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  }
`;

// Column-specific styles
export const ImagesColumn = styled(TableCell)`
  width: 100px;
  min-width: 100px;
  padding: 0.5rem 0.75rem;
`;

export const IdColumn = styled(TableCell)`
  width: 70px;
  min-width: 70px;
`;

export const BatchColumn = styled(TableCell)`
  width: 100px;
  min-width: 100px;
`;

export const OcrStatusColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
  text-align: center;
`;

export const UploadedAtColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const TitleColumn = styled(TableCell)`
  width: 320px;
  min-width: 320px;
`;

export const DescriptionColumn = styled(TableCell)`
  width: 260px;
  min-width: 260px;
`;

export const CategoryColumn = styled(TableCell)`
  width: 170px;
  min-width: 170px;
`;

export const SuggestedPriceColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const ConditionColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const CardNameColumn = styled(TableCell)`
  width: 170px;
  min-width: 170px;
`;

export const SetColumn = styled(TableCell)`
  width: 170px;
  min-width: 170px;
`;

export const YearColumn = styled(TableCell)`
  width: 90px;
  min-width: 90px;
`;

export const ProducerColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const RarityColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const SubSetColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const EditionColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const VariantColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const LanguageColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const AutographColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const CardNumberColumn = styled(TableCell)`
  width: 160px;
  min-width: 160px;
`;

export const MarketValueColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const GradeColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const DamageColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const GradedColumn = styled(TableCell)`
  width: 130px;
  min-width: 130px;
`;

export const SpecialFeaturesColumn = styled(TableCell)`
  width: 170px;
  min-width: 170px;
`;

export const SellingPointsColumn = styled(TableCell)`
  width: 200px;
  min-width: 200px;
`;

export const CardGameTypeColumn = styled(TableCell)`
  width: 170px;
  min-width: 170px;
`;

export const EbayTitleColumn = styled(TableCell)`
  width: 320px;
  min-width: 320px;
`;

export const EbayCategoryColumn = styled(TableCell)`
  width: 190px;
  min-width: 190px;
`;

export const EbayConditionColumn = styled(TableCell)`
  width: 150px;
  min-width: 150px;
`;

export const EbayDescriptionColumn = styled(TableCell)`
  width: 260px;
  min-width: 260px;
`;

export const CountryColumn = styled(TableCell)`
  width: 160px;
  min-width: 160px;
`;

export const ManufacturerColumn = styled(TableCell)`
  width: 180px;
  min-width: 180px;
`;

export const YearManufacturedColumn = styled(TableCell)`
  width: 170px;
  min-width: 170px;
`;

export const VintageColumn = styled(TableCell)`
  width: 140px;
  min-width: 140px;
`;

export const ConditionDescriptionColumn = styled(TableCell)`
  width: 260px;
  min-width: 260px;
`;

export const AvailableQuantityColumn = styled(TableCell)`
  width: 190px;
  min-width: 190px;
`;

// Image Components
export const CardImages = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 32px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardThumbnail = styled.img`
  width: 32px;
  height: 45px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  opacity: ${(props) => (props.loading ? 0 : 1)};
  transition: opacity 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const ImageLoader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border: 3px solid #f3f4f6;
  border-top: 3px solid #000000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  z-index: 10;

  @keyframes spin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
`;

// Cell Content Components
export const CellContent = styled.div`
  font-size: 0.875rem;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
  font-weight: 600;
`;

export const InlineInput = styled.input`
  width: 100%;
  padding: 0.25rem 0.5rem;
  border: 2px solid #3b82f6;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  color: black;
  background: white;
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
`;

export const InlineTextarea = styled.textarea`
  width: 100%;
  padding: 0.25rem 0.5rem;
  border: 2px solid #3b82f6;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  color: black;
  background: white;
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  resize: vertical;
  min-height: 60px;
  font-family: inherit;
`;

export const EditActions = styled.div`
  display: flex;
  gap: 0.25rem;
  margin-top: 0.25rem;
`;

export const InlineSaveButton = styled.button`
  padding: 0.25rem 0.5rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: #059669;
  }
`;

export const InlineCancelButton = styled.button`
  padding: 0.25rem 0.5rem;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: #4b5563;
  }
`;

// Magnified View Components
export const MagnifiedViewOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
`;

export const MagnifiedViewContainer = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const MagnifiedImagesRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 90vw;
`;

export const DualMagnifiedImage = styled.img`
  max-width: 44vw;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 2px solid white;
`;

export const MagnifiedImage = styled.img`
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 2px solid white;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

// Status Components
export const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
`;

export const StatusIcon = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`;

export const StatusText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
`;

export const RowStatusSelect = styled.select`
  padding: 0.5rem 2rem 0.5rem 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center;
  appearance: none;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #1f2937;
  outline: none;
  cursor: pointer;
  min-width: 110px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;

  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
  }

  &:hover {
    border-color: #9ca3af;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  appearance: none;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  background: white;
  position: relative;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
  }

  &:checked {
    background-color: #3b82f6;
    border-color: #3b82f6;
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
  }

  &:checked::after {
    content: "✓";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

// Pagination Components
export const DashboardPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;
  margin-top: 1.75rem;
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
`;

export const PaginationArrow = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  margin: 0 0.375rem;
  background: transparent;
  color: #6b7280;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;

  svg {
    display: block;
    width: 15px;
    height: 15px;
  }

  &:hover:not(.disabled) {
    background: #f3f4f6;
    color: #111827;
  }

  &:active:not(.disabled) {
    transform: translateY(0.5px);
  }

  &.disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

export const PageButton = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.375rem;
  background: ${(props) => (props.$active ? "#f3f4f6" : "transparent")};
  color: ${(props) => (props.$active ? "#111827" : "#374151")};
  border: 1px solid ${(props) => (props.$active ? "rgba(17, 24, 39, 0.12)" : "transparent")};
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: ${(props) => (props.$active ? 600 : 500)};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #f3f4f6;
  }
`;

export const PageEllipsis = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  color: #9ca3af;
  font-size: 0.8125rem;
`;

// Filter Components
export const FilterIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: #f3f4f6;
  }

  .ant-dropdown-trigger {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CustomDropdownWrapper = styled.div`
  .ant-dropdown-menu {
    min-width: fit-content !important;
    width: auto !important;
    padding: 4px;
    position: relative !important;
  }

  .ant-dropdown-menu-item {
    padding: 6px 12px !important;
    font-size: 0.8125rem;
    white-space: nowrap;
  }

  .ant-dropdown {
    position: relative !important;
  }
`;

// Reorder Placeholder
export const ReorderPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
`;

// Cards Per Page Components
export const CardsPerPageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-left: 0;
`;

export const CardsPerPageLabel = styled.span`
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
`;

export const CardsPerPageSelect = styled.select`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${(props) => (props.$active ? "#3b82f6" : "#d1d5db")};
  border-radius: 6px;
  background: ${(props) => (props.$active ? "#eff6ff" : "transparent")};
  color: #1f2937;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  min-width: 70px;
  outline: none;

  &:focus {
    background-color: #ffffff;
    border-color: #3b82f6;
    outline: none;
  }

  &:hover {
    background-color: #ffffff;
    border-color: #9ca3af;
  }
`;
